import type { AbioticStressProperties } from '@features/regional-overview/abiotic-stress/domain/abiotic-stress.models';
import {
  ALL_FILTER_VALUE,
  RegionalOverviewFilterType,
  buildFilter,
  type Filter
} from '@features/regional-overview/regional-overview.models';
import type { RegionalOverviewV2Properties } from 'querys/regional-overview/regional-overview.query.models';
import i18n from 'i18next';
import { sortFilterOptionsByLabel } from '../filter.utils';

export const buildCropsFilter = <P extends RegionalOverviewV2Properties | AbioticStressProperties>(
  defaultValue: string | undefined,
  includeAllOption: boolean
): Filter =>
  buildFilter<P>({
    type: RegionalOverviewFilterType.CROPS,
    defaultValue,
    includeAllOption,
    translatable: true,
    sortOptions: options => sortFilterOptionsByLabel(options, option => String(i18n.t(option.labelKey)), i18n.language),
    getValues: feature => {
      const cropName = feature.properties?.values?.crop_name;
      return cropName ? [cropName] : [];
    },
    matches: (feature, value) => {
      if (typeof value !== 'string' || value === ALL_FILTER_VALUE) return true;
      return feature.properties?.values?.crop_name === value;
    }
  });
